import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, TrophyIcon, XIcon } from 'lucide-react';
import { systemNegatives, totalBonuses, totalVolumes } from '../data/offer';
export function SystemSection() {
  return <section className="tech-grid-light bg-white py-16 sm:py-20" aria-labelledby="system-title" data-id="element-236" data-mp="3bhlk95796all">
      <div className="mx-auto max-w-4xl px-4 text-center" data-id="element-237" data-mp="36j0lla7nfyz9">
        <span className="inline-flex items-center gap-2 rounded-md bg-navy-900 px-4 py-2 text-xs font-extrabold uppercase tracking-[.15em] text-white" data-id="element-238" data-mp="31kgyh6hbkh5b">
          <TrophyIcon className="h-4 w-4 text-sun-400" aria-hidden="true" data-id="element-239" data-mp="2wsfltjg8ooer" /> El sistema más completo de gestión
          ambiental para el aula de habla hispana
        </span>
        <h2 id="system-title" className="mx-auto mt-5 max-w-3xl text-balance text-3xl font-extrabold text-navy-900 sm:text-4xl" data-id="element-240" data-mp="2nudfcodql3k3">
          Megapack Gestión Ambiental Listo
        </h2>
        <p className="mt-3 font-semibold text-navy-700" data-id="element-241" data-mp="2duuy4fp7nvvq">
          {totalVolumes} tomos · {totalBonuses} bonos estratégicos · Todo listo para usar desde hoy.
        </p>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3 text-left sm:grid-cols-3" data-id="element-242" data-mp="18py24kh2qljk">
          {systemNegatives.map(item => <motion.li key={item} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex gap-3 rounded-lg border border-navy-100 bg-canvas p-4 text-sm font-semibold text-navy-700" data-id="element-243" data-mp="u1tinea765zq">
              <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-red-600" aria-hidden="true" data-id="element-244" data-mp="1cs1innilogbp" />
              {item}
            </motion.li>)}
        </ul>

        <p className="mx-auto mt-8 flex max-w-3xl items-start gap-3 rounded-xl border border-leaf-200 bg-leaf-50 p-6 text-left text-lg font-bold leading-relaxed text-navy-900" data-id="element-245" data-mp="1hsphgvd2m1gh">
          <CheckIcon className="mt-1 h-6 w-6 shrink-0 text-leaf-600" aria-hidden="true" data-id="element-246" data-mp="6d0sxzk64udk" />
          Es un sistema para que entres al aula con confianza y dictes clases que de verdad enseñen cómo funciona la
          gestión ambiental y cómo responder a los desafíos ambientales.
        </p>
      </div>
    </section>;
}